import type { GuestRatingBreakdown } from '@libs/trip-planner-interfaces';

import type { GuestRatingSummary } from './customersRatingTag.model';

export function getGuestRating(
  guestRatings: GuestRatingBreakdown | undefined
): GuestRatingSummary | undefined {
  if (!guestRatings) {
    return undefined;
  }
  const overallScoreOverTen = guestRatings.overall
    ? guestRatings.overall * 2
    : undefined;

  const numberOfReviews = guestRatings.count || undefined;

  if (!overallScoreOverTen || !numberOfReviews) {
    return undefined;
  }

  return {
    overallScoreOverTen,
    numberOfReviews,
  };
}
